export const TYPES = {
  CARD_SORT_ITEM: 'CardSortItem',
  CARD_SORT_CATEGORY: 'CardSortCategory',
};

export const CARD_SORT_TYPES = {
  HYBRID: 'hybrid',
  OPENED: 'opened',
  CLOSED: 'closed',
};

export const ERROR_MESSAGE_ITEM = '1 or more cards are not sorted';
export const ERROR_MESSAGE_CATEGORY = '1 or more groups are not named';

export const firstScreen = 'Before we get started, please enter your first and last name.';
